module.exports = __webpack_public_path__ + "media/images/flower1-eb62cda4527c7f5caab8facb0d516233.png";